import React from 'react';
import ReactDOM from 'react-dom'; 
import { legacy_createStore as createStore } from 'redux'
import { Provider } from 'react-redux'
import reducer from './app/redux/reducers'; 
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import "primereact/resources/themes/lara-light-indigo/theme.css";  //theme
import "primereact/resources/primereact.min.css";                  //core css
import "primeicons/primeicons.css";                                //icons
import "primeflex/primeflex.css";
import i18n from "i18next";
import en_json from "./assets/locales/en.json";
import es_json from "./assets/locales/es.json";
import { initReactI18next } from "react-i18next";
import { HelmetProvider } from 'react-helmet-async';

import './index.scss';
import './theme.css';

import PrimeReact  from 'primereact/api';

PrimeReact.inputStyle = 'filled';
PrimeReact.autoZIndex = true;
PrimeReact.ripple = true;

 
const store = createStore(
  reducer
)

i18n
  .use(initReactI18next)  
  .init({ 
    resources: {
      en: {
        translation: en_json 
      } ,
      es: {
        translation: es_json
      }
    },
    lng: localStorage.getItem('translationMKT') != null ? localStorage.getItem('translationMKT'): 'en' , // if you're using a language detector, do not define the lng option
    fallbackLng: localStorage.getItem('translationMKT') != null ? localStorage.getItem('translationMKT'): 'en' ,
    interpolation: {
     // escapeValue: false // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
    }
  });

ReactDOM.render(
  <BrowserRouter>
   <React.StrictMode>
      <Provider store={store}>
        <HelmetProvider>
          <App />
        </HelmetProvider>
      </Provider> 
    </React.StrictMode>
  </BrowserRouter>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
